<template>
    <span>{{ dots }}
    </span>
</template>

<script>
  export default {
    data: function () {
      return {
        timer: null,
        secs: 0
      };
    },
    mounted () {
      this.timer = setInterval(() => this.count(), 700);
    },
    beforeDestroy () {
      clearInterval(this.timer);
    },
    methods: {
      count () {
        this.secs++;
      }
    },
    computed: {
      dots () {
        return '.'.repeat(this.secs % 4);
      }
    }
  };
</script>
